module.exports = __webpack_public_path__ + "img/56.e9dbd9eb.jpg";